export enum EBasicOverlays {
  BonusInfoDeposit,
  BonusInfoActivated,
  BonusInfo,
  BonusCancel,
  TournamentAllGames,
  AdditionalFields,
  InfoPage,
  PendingWithdrawalDialog, // Page 'cashier' overlay on click view
  TransactionDetailsContent, //Page 'transaction history' on click arrow right
  MobileSidebarSearch,
  HeaderAccount,
  NotificationsList,
  WelcomeBonuses,
  BonusInfoBundle,
  WelcomeBonusBundle,
  BonusInfoPromo,
  CloseMessage,
  PaymentChecklist,
  SportBonusInfo,
  LockedBySportBonus,
  RestrictedSport,
  SportRestrictedBonus,
  /**Descriptions of each icon */
  BrandBonusWheelDescription,
  /**Descriptions of each icon + bonus details*/
  BrandBonusWheelDescriptionLarge,
  /**Warning user about active bonus */
  BrandBonusOverride,
  /**Show user that he successfully active bonus or successfully stored it */
  BrandBonusWheelInfo,
  /**show user that he has lucky wheel bonus */
  BrandBonusHasLuckyWheel,
  /**show user that he hasn't lucky wheel bonus */
  BrandNoBonusLuckyWheel,
  SearchOverlay,
  LockedProvider,
  BrandBonusDescriptions,
}

export const NEW_DIALOG_COMPONENTS = [EBasicOverlays.PendingWithdrawalDialog];
